"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var OptionMessage_1 = __importDefault(require("./OptionMessage"));
var ui_1 = require("@aperza/ui");
var SearchResultHeader = /** @class */ (function (_super) {
    __extends(SearchResultHeader, _super);
    function SearchResultHeader(props) {
        var _this = _super.call(this, props) || this;
        _this.changeLimitForRecords = function (e) {
            _this.props.updateLimit(e.target.value);
        };
        return _this;
    }
    SearchResultHeader.prototype.render = function () {
        var pageMetadata = this.props.pageMetadata;
        return (react_1.default.createElement("div", { className: "rt-top" },
            react_1.default.createElement("span", { className: "headerCount" },
                react_1.default.createElement(ui_1.Message, { messageId: 'searchResultHeader.label', values: {
                        total: pageMetadata.totalRecords,
                        from: pageMetadata.recordsFrom,
                        to: pageMetadata.recordsTo,
                    } })),
            react_1.default.createElement("span", { className: "headerPageSizeDd" },
                react_1.default.createElement("select", { onChange: this.changeLimitForRecords },
                    react_1.default.createElement(OptionMessage_1.default, { optionValue: 10, messageId: 'searchResultHeader.limit', values: { limit: 10 } }),
                    react_1.default.createElement(OptionMessage_1.default, { optionValue: 20, messageId: 'searchResultHeader.limit', values: { limit: 20 } }),
                    react_1.default.createElement(OptionMessage_1.default, { optionValue: 30, messageId: 'searchResultHeader.limit', values: { limit: 30 } })))));
    };
    SearchResultHeader.propTypes = {
        pageMetadata: prop_types_1.default.object.isRequired,
    };
    return SearchResultHeader;
}(react_1.default.Component));
exports.default = SearchResultHeader;
